import { clsx } from "clsx";

interface AdaraSignetProps {
  className?: string;
}

export function AdaraSignet({ className }: AdaraSignetProps) {
  return (
    <svg
      viewBox="85 85 290 250"
      className={clsx("shrink-0", className)}
      aria-hidden="true"
    >
      {/* Gold accent triangle */}
      <defs>
        <linearGradient
          id="signet-gold"
          x1="321.6"
          y1="135.5"
          x2="343"
          y2="207.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#F8D280" />
          <stop offset="0.38" stopColor="#E1BC6F" />
          <stop offset="1" stopColor="#B69350" />
        </linearGradient>
      </defs>
      <polygon
        fill="url(#signet-gold)"
        points="311.6,236.2 317.5,225.5 368.9,132.6 333.7,132.6 294,204.4"
      />
      {/* Main A shape */}
      <polygon
        fill="currentColor"
        points="321,92 285.8,92 258.8,140.8 276.4,172.6"
      />
      <path
        fill="currentColor"
        d="M334.4,307.9c2.6,0,4.2-2.8,3-5l-113-204.1c-1.3-2.3-4.6-2.3-5.9,0L92.3,326.9h40.1L220,168.7c0.6-1.1,2.2-1.1,2.8,0l60,108.3h-64.2l26.5-47.9l-17.6-31.8l-58.4,105.5c-1.2,2.3,0.4,5,3,5L334.4,307.9z"
      />
    </svg>
  );
}
